export default Object.freeze({
  READY: 'ready',
  LOADING: 'loading',
  ERROR: 'error',
  INITIAL: 'initial'
})
